import { render, staticRenderFns } from "./AvaliacaoPsicossocialRadio.vue?vue&type=template&id=5885793a&scoped=true&"
import script from "./AvaliacaoPsicossocialRadio.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoPsicossocialRadio.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoPsicossocialRadio.vue?vue&type=style&index=0&id=5885793a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5885793a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
